module.exports = __webpack_public_path__ + "img/contact.7f8ab8a0.svg";